
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"#EA2D3F"}}),_c('g',{attrs:{"clip-path":"url(#clip0_15591_6267)","fill":"#fff"}},[_c('path',{attrs:{"d":"M9.279 16.644v-1.252a4.847 4.847 0 01-4.237-4.569l-.006-.24V9.371a.606.606 0 011.212 0v1.212l.005.18a3.636 3.636 0 003.632 3.457l.18-.005a3.635 3.635 0 003.451-3.451l.005-.18V9.37a.606.606 0 111.212 0v1.212a4.849 4.849 0 01-4.242 4.809v1.252a.606.606 0 01-1.212 0z"}}),_c('path',{attrs:{"d":"M9.885 3.917c-.563 0-1.103.207-1.5.576-.398.37-.622.87-.622 1.393v4.596a1.9 1.9 0 00.622 1.393c.397.37.937.577 1.5.577.562 0 1.102-.208 1.5-.577a1.9 1.9 0 00.62-1.393V5.886c0-.522-.223-1.023-.62-1.393a2.207 2.207 0 00-1.5-.577z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_15591_6267"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(4.885 4)","d":"M0 0h10.231v14.167H0z"}})])])])
          )
        }
      }
    